import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import 'dayjs/locale/et';
import utc from 'dayjs/plugin/utc';

dayjs.locale('et');
dayjs.extend(utc);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);

const formatCustomDate = (val: string | number, formatType: string) => String(val && formatType && dayjs(val).format(formatType));
const isDateBetween = (current: string, startTime: string, endTime: string) =>
  Boolean(current && startTime && endTime && dayjs(current).isBetween(startTime, endTime));
const isDateSameOrBefore = (date: string, beforeDate: string) => Boolean(date && beforeDate && dayjs(date).isSameOrBefore(beforeDate));

export { formatCustomDate, isDateBetween, isDateSameOrBefore };
